/**
 * Function to set new cursor for infinite scroll.
 *
 * @param cursor The cursor to set.
 */
export const setCursor = (cursor: string) => {
	const currentUrl = new URL(window?.location.href);

	const params = currentUrl.pathname.split('/').filter((param) => param !== '');

	window.history.replaceState(
		{},
		'',
		`${currentUrl.origin}/${params[0]}/${cursor}`
	);
};

/**
 * Function to delete cursor on the url param
 */
export const deleteCursor = () => {
	const currentUrl = new URL(window?.location.href);

	const params = currentUrl.pathname.split('/').filter((param) => param !== '');

	if (params[1] !== undefined) {
		window.history.replaceState({}, '', `${currentUrl.origin}/${params[0]}`);
	} else {
		return;
	}
};
